import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { ToastModule } from '@libs/src/toast/toast.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';

import { GroupsBackend } from '@libs/src/groups/groups.backend';
import { HubConfigRolesDrawerService } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-drawer/hub-config-roles-drawer.service';

import { HubConfigRolesDrawerComponent } from './hub-config-roles-drawer.component';

@NgModule({
  declarations: [HubConfigRolesDrawerComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    NzDrawerModule,
    ReactiveFormsModule,
    ToastModule,
    TtcButtonSharedModule,
    TtcMatInputModule,
  ],
  providers: [GroupsBackend, HubConfigRolesDrawerService],
})
export class HubConfigRolesDrawerModule {}
